import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Gallery from "./components/Gallery";
import Categories from "./components/Categories";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "AI美女生成平台",
            url: "https://ai-beauty-platform.com",
            description:
              "顶级AI图像生成技术，轻松生成高颜值AI美女写真、头像与壁纸",
            potentialAction: {
              "@type": "SearchAction",
              target:
                "https://ai-beauty-platform.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "AI美女生成需要什么技术基础吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "完全不需要！我们的AI美女生成平台专为普通用户设计，你只需要用文字描述你想要的形象即可。",
                },
              },
              {
                "@type": "Question",
                name: "生成的AI美女图像可以商用吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "是的，通过我们平台生成的AI美女图像均为原创虚拟形象，你可以自由用于个人和商业用途。",
                },
              },
              {
                "@type": "Question",
                name: "生成一张AI美女图像需要多长时间？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "通常情况下，从输入描述到生成图像只需5-15秒。",
                },
              },
              {
                "@type": "Question",
                name: "支持哪些分辨率和格式？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "我们支持多种分辨率输出，包括社交头像1:1、手机壁纸9:16、电脑壁纸16:9等比例。",
                },
              },
              {
                "@type": "Question",
                name: "如何提高AI美女生成的质量？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "提高生成质量的关键在于写好提示词，描述越详细越好，包括人物特征、风格定位、场景设定、光线氛围等。",
                },
              },
              {
                "@type": "Question",
                name: "平台支持哪些风格的AI美女？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "我们支持写真摄影、甜美可爱、高冷御姐、古典东方、现代时尚、梦幻唯美、赛博朋克等丰富风格。",
                },
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Gallery />
        <Categories />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}